
    var riot = require('riot')
    riot.tag2('contact-modal', '<contact-modal-form name="formModal" validator="{opts.validator}" breakpoint="{opts.breakpoint}" show-modal="{false}"></contact-modal-form> <contact-modal-success name="successModal" show-modal="{false}"></contact-modal-success> <contact-modal-abort name="abortModal" show-modal="{false}"></contact-modal-abort> <contact-modal-error name="errorModal" show-modal="{false}"></contact-modal-error>', '', '', function(opts) {
        this.initPayload = {};

        this.show = function(payload) {
            this.initPayload = payload;
            this.bus.trigger('ui:contact-modal:on-init', {payload: payload});
        }.bind(this);

        this.close = function() {
            this.bus.trigger('ui:contact-modal:on-close');

            if (this.initPayload.reloadAfterClose === true) {
                window.location.reload(true);
            }
        }.bind(this);

        this.on('mount', function () {
            this.bus.on('ui:contact-modal:show-modal', this.show);
            this.bus.on('ui:contact-modal:on-abort', this.close);
            this.bus.on('ui:contact-modal:message-sent-confirmed', this.close);
        }.bind(this));
});

    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal.riot.html